// Contexte d'authentification, séparé du composant AuthProvider et du hook useAuth :
// Fast Refresh ne recharge que les fichiers qui n'exportent que des composants.
import { createContext } from 'react';

export interface User {
    id: string;
    email: string;
    displayName: string;
    firstName: string;
    lastName: string;
    role: 'collaborator' | 'manager' | 'admin' | 'billing';
    department?: string;
    jobTitle?: string;
    managerId?: string;
    managerName?: string;
    isCdp?: boolean;
}

export interface AuthContextType {
    user: User | null;
    token: string | null;
    isLoading: boolean;
    isAuthenticated: boolean;
    login: () => Promise<void>;
    logout: () => void;
    isManager: boolean;
    isAdmin: boolean;
    isBilling: boolean;
    isCdp: boolean;
}

export const AuthContext = createContext<AuthContextType | null>(null);
